import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    textDecoration: "none",
  },
  button: {
    margin: "auto",
    display: "flex",
    fontSize: "1em",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    fontWeight: theme.typography.fontWeightBold,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.button.main,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.button.main,
      opacity: "0.7",
    },
    [theme.breakpoints.up("sm")]: {
      width: "66%",
      height: "3rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      whiteSpace: "nowrap",
      width: "auto",
    },
  },
}));

const CtaButton = ({ onClick }) => {
  const classes = useStyles();

  return (
    <a
      href="https://ams-cc.gofreem.de/accusation"
      className={classes.root}
    >
      <Button className={classes.button} onClick={onClick}>
        Einspruch Kostenlos prüfen
      </Button>
    </a>
  );
};

export default CtaButton;
